import React, { CSSProperties, useState } from 'react';

// eslint-disable-next-line import/no-named-default
import { default as i18n, default as i18next } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import useAuthentication from 'application/authentication/useAuthentication';
import DropDown from 'components/DropDown/DropDown';
import LoadingUserAvatar from 'components/LoadingUserAvatar/LoadingUserAvatar';
import { selectUserData } from 'redux/editProfile/userProfile.slices';
import { useAppSelector } from 'redux/hooks';
import deFlag from 'assets/germany-flag.png';
import { ReactComponent as CheckIcon } from 'assets/icons/checked.svg';
import { ReactComponent as ArrowIcon } from 'assets/icons/small-arrow.svg';
import usaFlag from 'assets/usa-flag.png';
import 'components/Modal/Modal.scoped.scss';
import './UserDropDown.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  boxStyle?: CSSProperties;
}

const UserDropDown: React.FC<Props> = ({ style }) => {
  const { logOut } = useAuthentication();
  const lang = i18n.language;
  const history = useHistory();
  const { t } = useTranslation('login');
  const [openModal, setOpenModal] = useState(false);
  const [checkedLang, setCheckedLang] = useState(lang);
  const userData = useAppSelector(selectUserData);

  const handleModal = () => {
    setOpenModal(prevState => !prevState);
  };

  const handleLanguage = value => {
    setCheckedLang(value);
  };

  const handleChangeLanguage = value => {
    handleLanguage(value);
    i18next.changeLanguage(value);
    handleModal();
    window.localStorage.setItem('lang', value);
  };

  const Icon = () => (
    <div className="avatar-dropdown">
      <LoadingUserAvatar height={40} width={40} />

      <div className="user-dropdown">
        <h4>
          {userData?.first_name} {userData?.last_name}
        </h4>

        {lang === 'en' ? (
          <p>
            {userData?.role === 'student'
              ? userData?.role
              : userData?.role === 'teacher'
              ? userData?.role
              : 'Parent'}
          </p>
        ) : (
          <p>
            {userData?.role === 'student'
              ? 'Studierende'
              : userData?.role === 'teacher'
              ? 'Dozent'
              : 'Elternteil'}
          </p>
        )}
      </div>
      <div className="filler hide-on-desktop" />
      <span className="arrow-down">&#9662;</span>
    </div>
  );

  const dropdownOptions = {
    editProfile: t('Edit Profile'),
    ...(userData?.role === 'teacher' && { createUser: t('common:create_user') }),
    language: (
      <>
        {checkedLang === 'de' ? (
          <div className={'flag-container'} onClick={() => handleChangeLanguage('de')}>
            <img src={deFlag} alt="DE flag icon" />
            <p>German {checkedLang === 'de' && <ArrowIcon style={{ marginLeft: '6px' }} />} </p>
          </div>
        ) : (
          <div className={'flag-container'} onClick={() => handleChangeLanguage('en')}>
            <img src={usaFlag} alt="DE flag icon" />
            <p>English {checkedLang === 'en' && <ArrowIcon style={{ marginLeft: '6px' }} />} </p>
          </div>
        )}
      </>
    ),
    signout: t('Sign out'),
  };

  function handleClick(value: string) {
    switch (value) {
      case 'login':
        break;
      case 'language':
        handleModal();
        break;
      case userData.role === 'teacher' && 'createUser':
        history.push('/create-user');
        break;
      case 'editProfile':
        history.push('/edit-profile');
        break;
      case 'signup':
        break;
      default:
        logOut();
        break;
    }
  }

  function handleEnter(value: string) {
    switch (value) {
      case 'language':
        setOpenModal(true);
        break;
      default:
        setOpenModal(false);
        break;
    }
  }

  return (
    <div className="avatar-container pointer" style={style}>
      {/* </Notification> */}
      <DropDown icon={Icon()}>
        <div className="two-dropdowns">
          <div className="dropdown-container">
            {Object.entries(dropdownOptions).map(([key, value]) => (
              <p key={key} onClick={() => handleClick(key)} onMouseEnter={() => handleEnter(key)}>
                {value}
              </p>
            ))}
          </div>
          {openModal && (
            <div className="extra-dropdown">
              <div className={'flag-container'} onClick={() => handleChangeLanguage('en')}>
                <img src={usaFlag} className="flag-img" />
                <p>English {checkedLang === 'en' && <CheckIcon className="check-icon" />}</p>
              </div>
              <div className={'flag-container'} onClick={() => handleChangeLanguage('de')}>
                <img src={deFlag} className="flag-img" />
                <p>German {checkedLang === 'de' && <CheckIcon className="check-icon" />} </p>
              </div>
            </div>
          )}
        </div>
      </DropDown>
    </div>
  );
};

export default UserDropDown;
